export const SET_SPACES = "SET_SPACES"
export const SET_SELECTED_SPACE_FOR_EDIT = "SET_SELECTED_SPACE_FOR_EDIT"
export const SET_MAX_SPACES = "SET_MAX_SPACES"